import { styled } from "../../../theme";
import { css } from "@emotion/react";
import { FlexColumn } from "../../../box";
export const Image = styled.img `
  height: 100%;
  width: 100%;
  max-height: 295px;
  margin-top: 20px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.primary};
  pointer-events: none;
  opacity: 0.6;
  filter: saturate(25%);
`;
export const Label = styled.label `
  font-size: 1.25em;
  line-height: 1.75em;
  opacity: 0.6;
  cursor: not-allowed;
  filter: saturate(25%);
`;
export const SignatureContainer = styled.div `
  width: 100%;
  max-width: 580px;
  margin: 0 auto;
  margin-bottom: 15px;

  ${({ disabled }) => disabled &&
    css `
      cursor: not-allowed;
    `}
`;
export const SignatureCanvasContainer = styled.div `
  div {
    color: ${({ theme }) => theme.color.primary};
    path {
      stroke: ${({ theme }) => theme.color.primary};
    }
    path:first-child {
      fill: ${({ theme }) => theme.color.primary};
    }
  }
  svg {
    fill: ${({ theme }) => theme.color.primary};
  }
  background-color: ${({ theme }) => theme.color.primary}10;

  cursor: pointer;
  position: relative;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.color.primary};
  transition: all 0.5s ease-in;
  ${({ filled }) => filled
    ? "background-color: #fff;"
    : "background-color:  rgba(43, 183, 217, 0.05);"}
  ${({ disabled }) => disabled &&
    `
      pointer-events: none;
      opacity: 0.6;
      filter: saturate(25%);
  `}
`;
export const Header = styled.div `
  display: grid;
  grid-template-columns: 1fr 4.335rem;

  margin-bottom: 20px;
  min-height: 30px; // Added space for ClearButton to not move when hidden

  ${({ theme }) => theme.media.md} {
    flex-wrap: nowrap;
    flex-direction: row;
  }
`;
export const ButtonLayoutWrapper = styled.div `
  display: flex;
  align-self: flex-end;
  ${({ theme }) => theme.media.md} {
    align-self: inherit;
  }
`;
export const DisplayWrapper = styled.div `
  display: none;
  ${({ isVisible }) => isVisible &&
    css `
      display: block;
    `}
`;
export const PlaceholderMessage = styled(FlexColumn) `
  justify-content: center;
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  line-height: 1.75em;
  font-size: 1.25em;
  color: ${({ theme }) => theme.color.primary};
  pointer-events: none;
  user-select: none;
`;
